import { FC } from "react";
import {
  HEADED_SECTION_DEFAULTS,
  THeadedSectionProps,
} from "./HeadedSection.config";
import { Section } from "../../layout/Section";
import { HeadedSectionHeader } from "./HeadedSectionHeader";
import { HeadedSectionContent } from "./HeadedSectionContent";

export const HeadedSection: FC<THeadedSectionProps> = ({
  title,
  theme = HEADED_SECTION_DEFAULTS.theme,
  "data-component": component = HEADED_SECTION_DEFAULTS["data-component"],
  icon,
  children,
}) => (
  <Section data-component={component}>
    <HeadedSectionHeader title={title} theme={theme} icon={icon} />
    <HeadedSectionContent theme={theme}>
      { children }
    </HeadedSectionContent>
  </Section>
);
